module.exports = __webpack_public_path__ + "static/img/recall-share-popup.ebfd01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestivalActive/recall/recall-share-popup.png
// module id = C5I2
// module chunks = 1